
import { Component, Prop, Vue } from "nuxt-property-decorator";
import { PrenotaVisitaPvp } from "@/types/responses/inserzione/PrenotaVisitaPvp";

@Component
export default class ThePvpLink extends Vue {
  @Prop({ required: true }) item!: any;
  public pvpPrenotaVisitaLoading: boolean = false;

  public showPvpPrenotaVisitaPvp() {
    if (this.item.tabs.hasOwnProperty("pvp")) {
      return this.item?.tabs?.info_vendita?.tipoPrenotaVisita === "PVP" || this.item?.tabs?.info_vendita?.tipoPrenotaVisita === "BOTH";
    }
  }

  public async goToPrenotaVisitaPvpLink() {
    this.pvpPrenotaVisitaLoading = true;
    let beneId = this.item?.tabs?.pvp?.groups?.dati_beni?.fields[0]?.fields?.find((a: any) => a?.label === "ID Bene PVP")?.value;

    if (beneId !== undefined && this.item.idInserzioneEspVendita) {
      try {
        let { data } = await this.$axios.$get<PrenotaVisitaPvp>(
          this.$config.astaEndpoint + "inserzioni/visitabile-pvp/" + this.item.idInserzioneEspVendita + "/" + beneId
        );
        if (typeof data?.link === "string") {
          this.openInNewTab(data.link);
        } else {
          this.$swal({
            html:
              '<div class="d-flex flex-column align-items-center justify-content-center" style="height:180px"><img class="my-4"src="https://files.venditeprivate.online/front/icons/warning.svg" width="60">' +
              `<h4 class="mb-2">Errore</h4>` +
              `<p class="mt-1 mb-0"><small>Errore col PVP o visita non prenotabile</small></p></div>`,
            showCloseButton: true,
            showCancelButton: false,
            confirmButtonText: "Ok",
            timer: 5000,
          });
        }
        this.pvpPrenotaVisitaLoading = false;
      } catch (e) {
        this.$swal({
          html:
            '<div class="d-flex flex-column align-items-center justify-content-center" style="height:180px"><img class="my-4"src="https://files.venditeprivate.online/front/icons/warning.svg" width="60">' +
            `<h4 class="mb-2">Errore</h4>` +
            `<p class="mt-1 mb-0"><small>Errore col PVP o visita non prenotabile</small></p></div>`,
          showCloseButton: true,
          showCancelButton: false,
          confirmButtonText: "Ok",
          timer: 5000,
        });
        throw e;
      }
    }
  }
  openInNewTab(href: string) {
    Object.assign(document.createElement("a"), {
      target: "_blank",
      rel: "noopener noreferrer",
      href: href,
    }).click();
  }
}
